function Ctrl($rootScope, $scope, metaTagService) {
  $scope.loading = true;

  metaTagService.set({
    title: 'Your Reviews | Tablelist',
    description: 'Write a review for the venues you\'ve visited and view the reviews you\'ve made in the past.'
  });

  $scope.bookingReviewPromise
    .then(() => {
      $scope.loading = false;
    });
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  'metaTagService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/accountReviews/accountReviewsCtrl.js